/**
 * Created by lihanying on 2017/7/7.
 */
import React from 'react'
import {
  Modal,
  Input,
  message,
  InputNumber,
  Radio,
  Row,
  Col,
  Checkbox,
  Select,
  Option,
  Switch,
  Form,
} from 'antd'
import { changeToDecimal, changeToDecimal1 } from '../../../util'
export default class extends React.Component {
  constructor(props) {
    super(props)
    const userInfo = this.props.userInfo
    console.log('userInfo', userInfo)
    this.state = {
      // value: '',
      value:
        'discount' in userInfo
          ? +changeToDecimal(+this.props.userInfo.discount * 10)
          : '',
      deadlineFlag: false, //是否设置过期折扣
      deadlineFlags: true,
      dataList: [
        {
          label: '日',
          value: 1,
        },
        {
          label: '月',
          value: 2,
        },
      ],
      dayText: '日',

      permit: true,
      discountName: '',
      discount: '',
      hasExpTime: false,
      expTime: 0,
      dayType: 1,
    }
  }

  componentDidMount() {
    this.setState({
      discountName: this.props.userInfo.name,
      discount: this.props.userInfo.discount,
      expTime: this.props.userInfo.number,
      dayType: this.props.userInfo.dayType,
      permit: this.props.userInfo.permit,
    })
    if (this.props.userInfo.number > 0) {
      this.setState({
        hasExpTime: true,
      })
    }
  }

  onChange = (value) => {
    console.log(value)
    if (value > 10) {
      message.info('折扣输入有误,请输入小于10')
    } else {
      // const discount = +changeToDecimal1(value)
      // this.setState({ value: discount })
      sessionStorage.setItem('discount', value)
    }
  }

  // onChange = (value) => {
  //   console.log(value)
  //   if (value >= 100) {
  //     message.info('时间输入有误，输入不能大于100天')
  //   } else if (value < 1) {
  //     message.info('时间输入有误，输入不能为负数')
  //   }
  // }

  limitDecimals = (value) => {
    const reg = /^(\-)*(\d+)\.(\d\d).*$/
    if ((value > 10 || value < 0) && !isNaN(Number(value))) {
      return ''
    }
    if (typeof value === 'string') {
      return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
    } else if (typeof value === 'number') {
      return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
    } else {
      return ''
    }
  }

  //打开关闭 限期折扣页面
  onDeadlineFlag = (e) => {
    this.setState(
      {
        deadlineFlag: e.target.checked,
      },
      () => {
        sessionStorage.setItem('deadlineFlag', e.target.checked)
      }
    )
  }

  //打开关闭 限期折扣页面
  onDeadlineFlags = (e) => {
    this.setState(
      {
        deadlineFlags: e.target.checked,
      },
      () => {
        sessionStorage.setItem('deadlineFlags', e.target.checked)
      }
    )
  }
  handleChange = (e) => {
    this.setState(
      {
        dayType: this.state.dataList[e].value,
        dayText: this.state.dataList[e].name,
      },
      () => {
        sessionStorage.setItem('dayType', this.state.dataList[e].value)
        sessionStorage.setItem('dayText', this.state.dataList[e].name)
      }
    )
  }

  onchangeSwitch = (check) => {
    this.setState({
      permit: check,
    })
  }

  childHandleOk = () => {
    const params = {
      name: this.state.discountName,
      discount: (this.state.discount / 10).toFixed(2),
      permit: this.state.permit,
      number: this.state.expTime,
      dayType: this.state.dayType,
      clubId: sessionStorage.getItem('club_id'),
      id: this.props.userInfo.id,
    }
    this.props.handleOk(params)
  }

  toggleExpTime = (e) => {
    this.setState({
      hasExpTime: e.target.checked,
    })
    if (!e.target.checked) {
      this.setState({
        expTime: 0,
        dayType: 1,
      })
    }
  }

  render() {
    const { visible, userInfo, action } = this.props
    const { deadlineFlag, dataList, deadlineFlags, hasExpTime } = this.state
    const Option = Select.Option

    return (
      <div>
        <Modal
          title={action === '-1' ? '添加等级' : '修改等级'}
          visible={visible}
          onOk={this.childHandleOk}
          onCancel={this.props.handleCancel}
          width="600px"
        >
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">等级名称:</span>
              <Input
                size="large"
                defaultValue={userInfo.name}
                style={{ width: '50%', marginLeft: '1rem' }}
                placeholder="请输入等级名称"
                // onChange={(e) => sessionStorage.setItem('name', e.target.value)}
                onChange={(e) =>
                  this.setState({ discountName: e.target.value })
                }
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <span className="info-span">等级折扣:</span>
              <InputNumber
                size="large"
                style={{ width: '50%', marginLeft: '1rem' }}
                placeholder="请输入等级折扣"
                defaultValue={userInfo.discount}
                formatter={this.limitDecimals}
                parser={this.limitDecimals}
                step={0}
                // onChange={(value) => this.onChange(value)}
                onChange={(e) => this.setState({ discount: e })}
              />
            </div>
            <div style={{ marginTop: '1rem' }}>
              <Form
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 3,
                }}
              >
                <Form.Item label="允许收银调整到该等级">
                  <Switch
                    onChange={this.onchangeSwitch}
                    defaultChecked={
                      Object.keys(this.props.userInfo).length == 0
                        ? true
                        : this.props.userInfo.permit
                    }
                  />
                </Form.Item>
              </Form>
            </div>
            <i style={{ color: '#108EE9', marginLeft: '-3.5rem' }}>
              注：等级折扣: 7.5 即为七五折, 等级折扣: 9 即为九折, 无折扣请输入10
            </i>
            <div style={{ marginTop: '1rem' }}>
              <Row className="marginTop">
                <Col span={11}>设置过期时间:</Col>
                <Checkbox
                  // checked={hasExpTime}
                  // onChange={this.onDeadlineFlags}
                  onChange={this.toggleExpTime}
                  defaultChecked={userInfo.number > 0}
                />
              </Row>
              {hasExpTime && (
                <div style={{ marginTop: '1rem', marginLeft: '10rem' }}>
                  <Row className="marginTop">
                    <InputNumber
                      size="large"
                      style={{ width: '45%', marginLeft: '1.5rem' }}
                      placeholder="请输入过期时间"
                      // onChange={(e) => sessionStorage.setItem('number', e)}
                      onChange={(e) => this.setState({ expTime: e })}
                      min={0}
                      max={100}
                      defaultValue={userInfo.number}
                    />

                    <Select
                      size="large"
                      style={{ marginLeft: '1rem', width: '20%' }}
                      // defaultValue={userInfo.dayType == 1 ? '日' : '月'}
                      defaultValue={userInfo.dayType}
                      // onChange={this.handleChange.bind(this)}
                      onChange={(e) => {
                        this.setState({
                          dayType: e,
                        })
                      }}
                    >
                      {this.state.dataList.map((item, index) => {
                        return (
                          <Select.Option value={item.value} key={item.value}>
                            {item.label}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Row>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      marginLeft: '5rem',
                      marginTop: '0.5rem',
                    }}
                  >
                    <i
                      style={{
                        color: '#d85757',
                        marginLeft: '-3.5rem',
                        display: 'inline',
                      }}
                    >
                      注1:有效期不能大于100
                    </i>
                    <i
                      style={{
                        color: '#d85757',
                        marginLeft: '-3.5rem',
                        display: '',
                      }}
                    >
                      注2: 限时折扣过期会变成默认折扣
                    </i>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubLevel/component/modal.js